import { restore, createEvent } from "effector";
import { persist } from "effector-storage/session";

export const changePage = createEvent<"tours" | "statistics">();

export const $page = restore(changePage, "tours");
persist({ store: $page, key: "page" });
